import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.sass']
})
export class ComingSoonComponent implements OnInit {
  @Input() title: string = 'Coming Soon';
  @Input() message: string = 'We are working on Billing Plans. Please reach out to our team to update the plan.';
  @Input() icon: string = 'construction';
  @Input() showContactButton: boolean = true;
  @Input() contactText: string = 'Contact Our Team';

  constructor() { }

  ngOnInit(): void {
  }

  onContactTeam(): void {
    // Navigate to the contact page
    window.open('https://www.totalhealthandfitness.com/contact/', '_blank');
  }
}